module.exports = __webpack_public_path__ + "resources/img/bg_toastcloud_center.5cbbc88a3b1571df4e15fe223a699c13.png";